/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {AdditionalEquipmentOptions} from "./additionalEquipmentOptions.zod";

export const HeliportFireFighting = zod.object({
  monitor: zod.boolean().nullish(),
  diffs: zod.boolean().nullish(),
  branchPipe: zod.boolean().nullish(),
  safeDeck: zod.boolean().nullish(),
  additionalOptions: AdditionalEquipmentOptions.and(zod.unknown()).optional(),
});

export type HeliportFireFighting = zod.input<typeof HeliportFireFighting>;
export type HeliportFireFightingOutput = zod.output<typeof HeliportFireFighting>;
